import { useCallback, useState } from 'react'
import translate from 'core/translate'
import { CatalogTabId } from '../templateEditor.types'
import { useTemplateEditorLeftPaneState } from './useTemplateEditorLeftPaneState'

/** Обвязка вокруг холста: имя шаблона, вкладка каталога, сворачивание/высоты панелей. */
export const useTemplateEditorChrome = () => {
    const [templateName, setTemplateName] = useState(translate('templateEditorUntitled'))
    const [catalogTab, setCatalogTab] = useState<CatalogTabId>('images')
    const leftPanes = useTemplateEditorLeftPaneState()

    const expandCatalogPane = useCallback(() => {
        leftPanes.setPaneCollapsed('catalog', false)
    }, [leftPanes.setPaneCollapsed])

    return {
        templateName,
        setTemplateName,
        catalogTab,
        setCatalogTab,
        collapsedPanes: leftPanes.collapsedPanes,
        paneHeights: leftPanes.paneHeights,
        togglePane: leftPanes.togglePane,
        setPaneCollapsed: leftPanes.setPaneCollapsed,
        setPaneHeight: leftPanes.setPaneHeight,
        expandCatalogPane,
    }
}
